import React, { useEffect, useState } from "react";


const PopupWrapper = ({ 
  isOpen, 
  onClose, 
  title, 
  children,
  isSecondary = false,
  isSmall = false,
}) => {
    const [animationClass, setAnimationClass] = useState('');

  useEffect(() => {
    if (isOpen) {
        setTimeout(() => {
            setAnimationClass('visible');
        }, 10);
    } else {
        setAnimationClass(''); 
    }
  }, [isOpen]);


  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (isOpen && event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscapeKey);
    }
    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className={`popUp ${animationClass}`} onClick={onClose}>
      <div 
        className={`p-5 animatedPopup ${isSecondary ? 'secondary' : 'primary'} ${animationClass} ${isSmall ? 'small' : 'large'}`} 
        onClick={(e) => e.stopPropagation()}
      >
        {title ? 
          (<div className="d-flex justify-content-between align-items-center mb-5">
            <h1 className="h4 text-gray-900">{title}</h1>      

            <button className="close-btn" onClick={onClose}>
              <i className="fas fa-times"></i>
            </button>
          </div>)
          : 
          (<button className="close-btn" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>)
        }
        
        {/* The actual form content will be passed as children */}
        <div className="content-container px-3 pt-3">
          {children}
        </div>
      </div>
    </div>
  );
};

export default PopupWrapper;